import {useTooltip} from 'components/Tooltip/hook';
import useFormError from 'hooks/useFormErrors';
import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {twMerge} from 'tailwind-merge';

import Field from '../Field';
import {FormContextString, InputProps} from '../types';
import {getRegisterRules} from '../utils';

const InputText: FC<InputProps> = ({
    className,
    classNameInput,
    disabled,
    error,
    helpText,
    id,
    isCompact,
    label,
    maxLength,
    name,
    readOnly,
    required,
    requiredType,
    rules,
    ...rest
}) => {
    const {setTooltipRef} = useTooltip();

    const {register} = useFormContext<FormContextString>();

    const registerRules = getRegisterRules({disabled, required, rules});

    const {ref, ...registration} = register(name, registerRules);

    const fieldError = useFormError(name, error);

    return (
        <Field
            className={className}
            disabled={registerRules?.disabled || readOnly}
            error={fieldError}
            helpText={helpText}
            label={label}
            maxLength={maxLength}
            name={name}
            required={!!registerRules?.required}
            requiredType={requiredType}
            type="input"
        >
            <input
                aria-label={
                    rest['aria-label'] || label === null
                        ? undefined
                        : typeof label === 'string'
                          ? label
                          : name
                }
                className={twMerge(
                    isCompact && 'h-8 text-sm',
                    fieldError && 'input-invalid',
                    classNameInput,
                )}
                id={id || name}
                maxLength={maxLength}
                readOnly={readOnly}
                ref={(r) => {
                    ref(r);
                    setTooltipRef(r);
                }}
                {...registration}
                tabIndex={readOnly ? -1 : undefined}
                type="text"
                {...rest}
            />
        </Field>
    );
};

export default InputText;
